import styled, { css } from 'styled-components';
import {
  BasePanel,
  BasePaginatorHeader,
  BasePaginatorListItem,
} from 'styles/components';
import { Colors } from 'styles/constants';

export {
  ActionButton,
  ActivityIndicator,
  Button,
  CompanyIcon as BuildingIcon,
  EditIcon,
  EmptyListPlaceholder,
  ModalBody,
  ModalContent,
  ModalHeader,
  PlusIcon,
} from 'styles/components';

export const MainPanel = styled(BasePanel)`
  flex: 0 1 100%;
  flex-direction: column;
  background: ${Colors.White};
  padding: 24px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
`;

const grid = css`
  grid-template-columns: 60px 220px 180px 1fr;
`;

export const ListHeader = styled(BasePaginatorHeader)`
  ${grid}
`;

export const ListItem = styled(BasePaginatorListItem)`
  ${grid}
`;

export const Column = styled.div``;

export const ActionsColumn = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
`;
